import type { JsObservabilitySurface } from "./contracts";

function sanitizeReleaseIdentity(value?: string | null): string {
  const normalizedValue = value?.trim().toLowerCase() ?? "";
  const sanitizedValue = normalizedValue
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return sanitizedValue || "dev";
}

export function buildSurfaceRelease(
  surface: JsObservabilitySurface,
  identity?: string | null,
): string {
  return `${surface}-${sanitizeReleaseIdentity(identity)}`;
}

export function resolveSharedRelease(options: {
  surface: JsObservabilitySurface;
  release?: string | null;
  releaseIdentity?: string | null;
}): string {
  if (options.release?.trim()) {
    return options.release.trim();
  }

  return buildSurfaceRelease(options.surface, options.releaseIdentity);
}
